import { createFileRoute } from '@tanstack/react-router';
import { LegalShell } from '@/components/legal/LegalShell';
import { ContentProse } from '@/components/prose';
import privacyMarkdown from '../content/legal/privacy.md?raw';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <LegalShell title="Privacy Policy">
      <ContentProse source={privacyMarkdown} />
    </LegalShell>
  );
}
